const Table = ({children}) => {
    return (
        <div className="overflow-x-auto flex flex-col w-full pt-10">
            <div className="inline-block w-full px-8 border-gray-200">
                <div className="overflow-y-hidden overflow-x-auto rounded-lg shadow border-b">
                    <table className="w-full overflow-auto ">
                        {children}
                    </table>
                </div>
            </div>
        </div>
    )
}
export default Table;